import { createNode } from '@glueapp/graph-types';

export const BooleanToNumber = createNode({
    id: 'Boolean To Number',
    name: 'Boolean To Number',
    category: 'Conversion',
    description: 'Returns 0 for false and 1 for true',
    aiDescription:
        'Converts a boolean to a number (false becomes 0, true becomes 1). Connect a boolean to the "Boolean" input port; the "Number" output port provides the numeric result.',
    color: '#a6aa11',
    integration: undefined,
    inPorts: {
        Boolean: { kind: 'boolean' },
    },
    outPorts: {
        Number: { kind: 'number' },
    },
    execute: function (input) {
        return { output: { Number: Number(input.inPorts.Boolean) } };
    },
});
